// extracted by mini-css-extract-plugin
export default {"resultSection":"ResultSection_resultSection__-wlXF","points":"ResultSection_points__5+0nn"};